import React, { useContext } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Login from "./components/auth/Login";
import Users from "./components/users/Users";
import NewUser from "./components/users/NewUser";
import EditUser from "./components/users/EditUser";
import Navbar from "./components/layout/Navbar";
import AuthContext from "./context/AuthContext";
import ServiceList from "./components/services/ServiceList";
import NewService from "./components/services/NewService";
import Start from "./components/layout/Start";
import Scan from "./components/scan/Scan";
import Profil from "./components/users/Profil";
import EditHomescreen from "./components/settings/editHomescreen";
import ServiceSettings from "./components/settings/service-settings";
import EditService from "./components/services/EditService";
import AppSettings from "./components/settings/app-settings";
import Projects from "./components/layout/Projects";
import Translations from "./components/settings/translations";
import Changelog from "./components/settings/changelog";
import ProjectUsers from "./components/users/ProjectUsers";
import EditProjectUser from "./components/users/EditProjectUser";
import NewOrder from "./components/services/NewOrder";
import EditOrder from "./components/services/EditOrder";
import NewAutoOrder from "./components/services/NewAutoOrder";
import OrderList from "./components/services/OrderList";
import Abnahmeprotokoll from "./components/services/Abnahmeprotokoll";
import Invoice from "./components/services/Invoice";
import OrderApproval from "./components/services/OrderApproval";
import Arbeitsplan from "./components/services/Arbeitsplan";
import Abrechnung from "./components/services/Abrechnung";
import ImportLv from "./components/settings/import-lv";
import DropdownOption from "./components/users/dropdownOptions";
import NewDropdownOption from "./components/users/newDropdownOptions";
import EditDropdownOption from "./components/users/editDropdownOption";
import Support from "./components/users/Support";
import NewTicket from "./components/users/newTicket";

function Router() {
  const { loggedIn } = useContext(AuthContext);

  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <div className="max-w-full mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <Switch>
              {window.location.href.includes("scan") && (
                <>
                  <Route path="/scan/:id">
                    <Scan />
                  </Route>
                </>
              )}

              {loggedIn === false && !window.location.href.includes("scan") && (
                <>
                  <Redirect to="/login" />
                  <Route path="/login">
                    <Login />
                  </Route>
                </>
              )}
              {loggedIn === true && (
                <>
                  <Route exact path="/users">
                    <Users />
                  </Route>
                  <Route exact path="/support/new">
                    <NewTicket />
                  </Route>
                  <Route exact path="/support">
                    <Support />
                  </Route>
                  <Route exact path="/project-users">
                    <ProjectUsers />
                  </Route>
                  <Route exact path="/dropdownoptions">
                    <DropdownOption />
                  </Route>

                  <Route exact path="/edit-homescreen">
                    <EditHomescreen />
                  </Route>
                  <Route exact path="/service-settings">
                    <ServiceSettings />
                  </Route>
                  <Route exact path="/profil">
                    <Profil />
                  </Route>
                  <Route exact path="/users/new">
                    <NewUser />
                  </Route>
                  <Route exact path="/dropdownoption/new">
                    <NewDropdownOption />
                  </Route>
                  <Route exact path="/dropdownoptions/edit/:id">
                    <EditDropdownOption />
                  </Route>

                  <Route path="/users/edit/:id">
                    <EditUser />
                  </Route>
                  <Route path="/users/edit-project-user/:id">
                    <EditProjectUser />
                  </Route>
                  <Route exact path="/services">
                    <ServiceList />
                  </Route>
                  <Route exact path="/orders/abnahmeprotokoll">
                    <Abnahmeprotokoll />
                  </Route>
                  <Route exact path="/orders/arbeitsplan">
                    <Arbeitsplan />
                  </Route>
                  <Route exact path="/orders/invoice">
                    <Invoice />
                  </Route>
                  <Route exact path="/abrechnung">
                    <Abrechnung />
                  </Route>
                  <Route exact path="/orders">
                    <OrderList />
                  </Route>
                  <Route exact path="/order-approval">
                    <OrderApproval />
                  </Route>
                  <Route exact path="/import-lv">
                    <ImportLv />
                  </Route>
                  <Route exact path="/add-order/:id">
                    <NewOrder />
                  </Route>
                  <Route exact path="/add-auto-order/:id">
                    <NewAutoOrder />
                  </Route>
                  <Route exact path="/edit-order/:id">
                    <EditOrder />
                  </Route>
                  <Route exact path="/app-settings">
                    <AppSettings />
                  </Route>
                  <Route exact path="/services/new">
                    <NewService />
                  </Route>
                  <Route exact path="/services/edit/:id">
                    <EditService />
                  </Route>
                  <Route exact path="/projects">
                    <Projects />
                  </Route>
                  <Route exact path="/translations">
                    <Translations />
                  </Route>
                  <Route exact path="/changelog">
                    <Changelog />
                  </Route>
                  <Route exact path="/">
                    <Start />
                  </Route>
                </>
              )}
            </Switch>
          </div>
        </div>
      </main>

      <footer class="bg-white shadow ">
        <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
          <span class="text-sm  sm:text-center">
            © 2025{" "}
            <a href="https://indutec-holding.de/" class="hover:underline">
              Indutec Int. Holding GmbH & Co. KG
            </a>
            . Alle Rechte vorbehalten.
          </span>
          <ul class="flex flex-wrap items-center mt-3 text-sm font-medium  sm:mt-0">
            <li>
              <a
                href="https://indutec-holding.de/impressum.html"
                class="hover:underline me-4 md:me-6"
              >
                Impressum
              </a>
            </li>
            <li>
              <a href="changelog" class="hover:underline me-4 md:me-6">
                Version 1.0
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </BrowserRouter>
  );
}

export default Router;
